import { render, staticRenderFns } from "./IkkatsuDaimonUpload.vue?vue&type=template&id=6df22e7f&"
import script from "./IkkatsuDaimonUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuDaimonUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports